import { setShowUploadModal } from '../State/showUploadModal';

export default (event) => async (dispatch, getState) => {
    
  const { currentDirectoryPath } = getState().screens.ProjectView

  // Check if this is an internal drag (moving items within the file manager)
  // Internal drags will have dataTransfer types set by our drag handlers
  const types = event.dataTransfer.types || [];
  const isInternalDrag = types.includes('sourcepath') || types.includes('sourcetype');
  
  // Tree drags from Ant Design have specific effectAllowed
  const isTreeDrag = event.dataTransfer.effectAllowed === 'move' && types.length > 0 && !types.includes('Files');
  
  // External file drags from OS will have 'Files' type
  const hasFiles = types.includes('Files');

  // Only show upload modal for external file drags (from file system)
  if (currentDirectoryPath && hasFiles && !isInternalDrag && !isTreeDrag) {
    
    dispatch(setShowUploadModal(true));

  }
}